import React, { FC } from 'react';
import { useArchivedProjectsQuery } from 'queries';
import { ArchivedProjectsList } from './archived-projects-list';

export const ArchivedProjects: FC = () => {
  const { data: projectList = [], isLoading } = useArchivedProjectsQuery();

  return (
    <ArchivedProjectsList
      data={projectList}
      loading={isLoading}
      data-test-id="project.archived_projects.list"
    />
  );
};
